(function() {
    'use strict';
    angular
        .module('consulatApp')
        .factory('Members', Members)
        .factory('MemberMultiParams', MemberMultiParams)
        .factory('MemberExisting', MemberExisting)
        .factory('MemberCandidats', MemberCandidats)
        .factory('MembersSaveVote', MembersSaveVote)
        .factory('CarteMultiParams', CarteMultiParams)
        .factory('MembersResultatVote', MembersResultatVote);

        
    Members.$inject = ['$resource', 'DateUtils'];
    MemberMultiParams.$inject = ['$resource', 'DateUtils'];
    MemberExisting.$inject = ['$resource', 'DateUtils'];
    MemberCandidats.$inject = ['$resource', 'DateUtils'];
    MembersSaveVote.$inject = ['$resource', 'DateUtils'];
    CarteMultiParams.$inject = ['$resource', 'DateUtils'];
    MembersResultatVote.$inject = ['$resource', 'DateUtils'];

    function CarteMultiParams ($resource, DateUtils) {
        var resourceUrl =  'api/cartes/findByParams';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                    }
                    return data;
                }
            }
        });
    }



    function MemberMultiParams ($resource, DateUtils) {
        var resourceUrl =  'api/members/findByParams';

        return $resource(resourceUrl, {}, {
                'query': {
                         method: 'GET',
                         isArray: true,
                    transformResponse: function (data) {
                         if (data) {
                                   data = angular.fromJson(data);
                                   console.log(data);
                                   data.forEach(function(item) {
                                      item.dateNaissance = DateUtils.convertLocalDateFromServer(item.dateNaissance);
                                     item.dateArrivee = DateUtils.convertLocalDateFromServer(item.dateArrivee);
                                    if (item.country && item.country !== null && item.country.dateDelivr) {
                                         item.country.dateDelivr = DateUtils.convertLocalDateFromServer(item.country.dateDelivr);
                                        }                         
                                        
                                    if (item.country && item.country !== null && item.country.dateExpr) {
                                        item.country.dateExpr = DateUtils.convertLocalDateFromServer(item.country.dateExpr);
                                        }        
                });
            }
            return data;
        }
    },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            }
        });
    }

    function MemberCandidats ($resource, DateUtils) {
        var resourceUrl =  'api/members/candidats';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            }
        });
    }

    function MemberExisting ($resource, DateUtils) {
        var resourceUrl =  'api/members/test';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);

                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);

                }
            },
            'sauvegarder': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);

                }
            }
        });
    }

    function MembersSaveVote ($resource, DateUtils) {
        var resourceUrl =  'api/members/saveVote';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            }
        });
    }


    function MembersResultatVote ($resource, DateUtils) {
        var resourceUrl =  'api/members/vote-resultat';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            },
        });
    }




    function Members ($resource, DateUtils) {
        var resourceUrl =  'api/members/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateNaissance = DateUtils.convertLocalDateFromServer(data.dateNaissance);
                        data.dateArrivee = DateUtils.convertLocalDateFromServer(data.dateArrivee);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateNaissance = DateUtils.convertLocalDateToServer(copy.dateNaissance);
                    copy.dateArrivee = DateUtils.convertLocalDateToServer(copy.dateArrivee);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
